// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

interface SubHeaderImmobiliProps {
  bodyTitle: string;
  filters: { [key: string]: string[] };
}

const SubHeaderImmobili: React.FC<SubHeaderImmobiliProps> = ({ bodyTitle, filters }) => {
  const { t } = useTranslation();

  // Impostiamo il titolo finale e lo sfondo di default
  let finalTitle = bodyTitle;
  let backGround = "";

  // Estraiamo l'array delle tipologie dai filtri
  const tipologie = filters['tipologia'] || [];

  if (tipologie.length > 0) {
    // Caso: Appartamenti -> se l'array contiene solo il valore "1"
    if (tipologie.length === 1 && tipologie[0] === "1") {
      finalTitle = t('property.typeTitles.apartments'); // Traduci
      backGround = "sub_appartamenti";
    }
    // Caso: Ville -> se tutti i valori presenti sono tra "15", "16" o "18"
    else if (tipologie.every(val => ["15", "16", "18"].includes(val))) {
      finalTitle = "Villette a schiera, villetta bifamiliare, villa";
      backGround = "sub_villa";
    }
    // Caso: Casali -> se l'array contiene solo il valore "73"
    else if (tipologie.length === 1 && tipologie[0] === "73") {
      finalTitle = "Casali";
      backGround = "sub_casale";
    }
  }

  return (
    <div id="subHeader_default" className={backGround}>
      <div className="container">
        <div className="row flex-column align-items-center text-center">
            <h1 className="text-white">{finalTitle}</h1>
            <p className="subTitle-reverse">{finalTitle}</p>
        </div>
      </div>
    </div>
  );
};

export default SubHeaderImmobili;